var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline"},[_c('h1',[_vm._v("Hyperloop vs "),_c('span',[_vm._v(_vm._s(_vm.headlineVehicles[_vm.current]))])]),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }